import { createModuleStore } from '../utils'

export const useNotificationConfigsStore = createModuleStore(
  'notification-configs',
  {
    type: 'TrackStar Mailer',
    pageHeading: 'TrackStar Mailers',
    noHistory: true,
    sortingOn: 'toolbar',
    noCopy: false,
    noAdd: false,
    statusesFilterName: 'statuses',
    uploadOptionsCsv: '',
    uri: '/notification-configs',
    serviceUri: '/notification-configs',
    listingModuleName: 'Config',
    listingActivityName: 'View Notification Config',
    formModuleName: 'Config',
    formActivityName: 'Edit Notification Config',
    allFields: [
      { key: 'name', title: 'NAME', visible: true, disabled: true, sortable: true },
      { key: 'description', title: 'DESCRIPTION', visible: true, disabled: true, sortable: true },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
  },
  {},
  {
    resetPageFilters() {
      const store = useNotificationConfigsStore()
      store.resetBaseFilters()
    },
    copy(item) {
      const obj = {
        alias: item.alias,
        body: item.body,
        type: item.type,
        sender: item.sender,
        description: item.description,
        subject: item.subject,
      }
      return obj
    },
    transform(item) {
      const obj = {
        externalId: item.externalId,
        body: item.body,
        sender: item.sender,
        alias: item.alias,
        recipients: item.recipients,
        type: item.type,
        name: item.name,
        subject: item.subject,
        description: item.description,
      }
      obj.recipientsEmails = obj?.recipients?.map((d) => d?.email)?.filter((d) => d)
      obj.recipientsNames = obj?.recipients?.map((d) => d?.name)?.filter((d) => d)
      return obj
    },
  },
  {
    fields: [
      {
        id: 'notification_type',
        name: 'type',
        label: 'Type',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter type of the mailer' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'notification_name',
        name: 'name',
        label: 'Name',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter name of the mailer' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'notification_sender',
        name: 'sender',
        label: 'Sender',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter sender of the mailer' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'notification_alias',
        name: 'alias',
        label: 'Template Alias',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter alias of the mailer' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'notification_subject',
        name: 'subject',
        label: 'Subject',
        size: 12,
        component: 'NInput',
        componentProps: { placeholder: 'Enter subject of the mailer' },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'notification_description',
        name: 'description',
        label: 'Description',
        size: 12,
        component: 'NInput',
        componentProps: { placeholder: 'Enter description of the mailer' },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'notification_body',
        name: 'body',
        label: 'Message Body',
        size: 24,
        component: 'NInput',
        componentProps: { placeholder: 'Enter body of the mailer', type: 'textarea' },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'notification_recipients',
        name: 'recipients',
        label: 'Recipients',
        defaultValue: [],
        size: 12,
        visible: false,
        component: '',
        componentProps: {
          multiple: true,
          placeholder: '',
        },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'notification_reciepients_names',
        name: 'recipientsNames',
        label: 'Names',
        forSubmitOnly: true,
        visible: false,
        size: 12,
        componentProps: {},
      },
      {
        id: 'notification_reciepients_emails',
        name: 'recipientsEmails',
        label: 'Emails',
        forSubmitOnly: true,
        visible: false,
        size: 12,
        componentProps: {},
      },
    ],
  }
)
